import React from "react";
import { Popover as PopoverPrimitive } from "radix-ui";

const NAME = "PopoverPortal";

export type PopoverPortalProps = PopoverPrimitive.PopoverPortalProps;

export const PopoverPortal = (props: PopoverPortalProps) => (
  <PopoverPrimitive.Portal {...props}>{props.children}</PopoverPrimitive.Portal>
);

PopoverPortal.displayName = NAME;
